import { request } from '../lib/http'

export function fetchAll () {
  return request({
    url: 'actives-type',
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: `actives-type`,
    method: 'get',
    params: queriesParams
  })
}

export function addActivesType (activesType) {
  return request({
    method: 'post',
    url: 'actives-type',
    data: activesType
  })
}

export function show (id) {
  return request({
    url: `actives-type/${id}`,
    method: 'get'
  })
}

export function edit (id, data) {
  return request({
    url: `actives-type/${id}`,
    method: 'patch',
    data
  })
}